<template>
  <div>
    <VCard title="Role 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'auth-role',
  },  
})
</script>
